import { ESearchModalState } from '../../../../../types/searchModal';

export function getSearchModalEmptyColor(state: ESearchModalState) {
  switch (state) {
    case ESearchModalState.EmptySuggest:
    case ESearchModalState.EmptyTags:
      return '#737a8e';
    case ESearchModalState.SuggestError:
      return '#ff1f34';
    default:
      return null;
  }
}
